/* ===== JAVASCRIPT CODE ===== */
/* Add this script to your theme's footer or custom JS section */

document.addEventListener('DOMContentLoaded', function() {
    // Get your specific header elements
    const mainHeader = document.querySelector('.hdt-main-header');
    const bottomHeader = document.querySelector('.hdt-bottom-header');
    
    // Exit if headers not found
    if (!mainHeader || !bottomHeader) {
        console.log('Headers not found');
        return;
    }
    
    // Calculate header heights dynamically
    const mainHeaderHeight = mainHeader.offsetHeight;
    const totalHeaderHeight = mainHeaderHeight + bottomHeader.offsetHeight;
    
    // Set CSS custom properties for responsive heights
    document.documentElement.style.setProperty('--main-header-height', mainHeaderHeight + 'px');
    document.documentElement.style.setProperty('--total-header-height', totalHeaderHeight + 'px');
    
    // Set initial position for bottom header
    bottomHeader.style.top = mainHeaderHeight + 'px';
    
    // Scroll variables
    let lastScrollTop = 0;
    let ticking = false;
    
    // Throttle function for better performance
    function requestTick() {
        if (!ticking) {
            requestAnimationFrame(updateHeaders);
            ticking = true;
        }
    }
    
    // Main scroll handler
    function updateHeaders() {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const scrollThreshold = 50; // Adjust this value as needed (pixels scrolled before transition)
        
        if (scrollTop > scrollThreshold) {
            // Scrolling down - hide main header, move bottom header to top
            mainHeader.classList.add('header-hidden');
            bottomHeader.classList.add('menu-scrolled');
        } else {
            // At top of page - show main header, return bottom header to normal position
            mainHeader.classList.remove('header-hidden');
            bottomHeader.classList.remove('menu-scrolled');
        }
        
        lastScrollTop = scrollTop;
        ticking = false;
    }
    
    // Add scroll listener
    window.addEventListener('scroll', requestTick);
    
    // Initial check in case page loads scrolled down
    updateHeaders();
    
    // Recalculate on window resize (for responsive design)
    window.addEventListener('resize', function() {
        const newMainHeaderHeight = mainHeader.offsetHeight;
        const newTotalHeaderHeight = newMainHeaderHeight + bottomHeader.offsetHeight;
        
        document.documentElement.style.setProperty('--main-header-height', newMainHeaderHeight + 'px');
        document.documentElement.style.setProperty('--total-header-height', newTotalHeaderHeight + 'px');
        
        if (!bottomHeader.classList.contains('menu-scrolled')) {
            bottomHeader.style.top = newMainHeaderHeight + 'px';
        }
    });
});
